(function () {
  const init = () => {
    const buttons = document.querySelectorAll('[data-landing-banner-add]');
    if (!buttons.length) return;

    buttons.forEach((button) => {
      button.addEventListener('click', async (e) => {
        e.preventDefault();

        const variantId = button.dataset.variantId;
        if (!variantId) return;

        const quantity = parseInt(button.dataset.quantity || '1', 10) || 1;

        const config =
          typeof fetchConfig === 'function'
            ? fetchConfig('javascript')
            : { method: 'POST', headers: { Accept: 'application/json' } };

        config.headers = config.headers || {};
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        if (config.headers['Content-Type']) delete config.headers['Content-Type'];

        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', String(quantity));

        config.body = formData;

        button.setAttribute('aria-disabled', 'true');
        button.classList.add('loading');

        try {
          // Check cart first — if variant already exists, set qty to 1 instead of adding
          const cartRes = await fetch('/cart.js');
          const cart = await cartRes.json();
          const existing = cart.items.find((i) => i.variant_id === Number(variantId));

          if (existing) {
            if (existing.quantity !== 1) {
              await fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
              });
            }
          } else {
            const res = await fetch(`${routes.cart_add_url}`, config);
            const data = await res.json();
            if (data.status) {
              console.error(data);
              button.removeAttribute('aria-disabled');
              button.classList.remove('loading');
              return;
            }
          }

          window.location.assign('/checkout');
        } catch (err) {
          console.error(err);
        } finally {
          button.classList.remove('loading');
          button.removeAttribute('aria-disabled');
          if (typeof AOS !== 'undefined') AOS.init();
        }
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

